import React, { Component } from 'react';
import DataFetcher from '../utils/DataFetcher';
import DeviceLogPage from '../components/DeviceLogPage';
import CommonUtils from '../utils/CommonUtils';

class DeviceLogOfDelegate extends Component {
  constructor(props) {
    super(props)
    this.deviceId = decodeURIComponent(this.props.match.params.deviceId)
    this.delegateId = CommonUtils.resolveSearchParam(this.props.location, 'delegateId')
  }

  render() {
    const pageProps = {
      fetchLogs: (params, callback) => {
        DataFetcher.delegateDeviceLogs(
          {
            ...params,
            delegateId: this.delegateId,
            deviceId: this.deviceId,
          }, 
          {
            success: callback
          }
        )
      }
    }

    return <DeviceLogPage {...pageProps}/>
  }
}

export default DeviceLogOfDelegate;


// WEBPACK FOOTER //
// ./src/modules/DeviceLogOfDelegate.js